import { deepComputedFrom } from 'aurelia-deep-computed';
import { autoinject, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { QueryFilter } from 'model/essential-types';
import { QueryMemory } from 'support/shared_models/query-memory';

@autoinject
@customElement('clear-filters-toolbar-component')
export class ClearFiltersToolbarComponent {
  @bindable
  public queryMemory: QueryMemory<QueryFilter> = null;
  @bindable
  public hint: any = undefined;

  @deepComputedFrom('queryMemory.filter')
  private get canClear() {
    return this.queryMemory.filter?.canClear(this.hint) ?? false;
  }

  clear() {
    this.queryMemory.filter.clear(this.hint);
  }
}
